import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1, // Let GET requests retry once
        },
        mutations: {
            retry: false, // Do not retry POST/PUT/DELETE by default
        }
    },
});
